module.exports = __webpack_public_path__ + "img/l_dt.6f189ae8.png";